/**
 * Draft recovery for long admin forms (e.g. the product editor).
 *
 * A failed save must never cost the admin the work they typed. The in-memory form
 * state is preserved anyway (the form is not reset/closed on failure); this adds a
 * safety net for accidental reloads/navigations during a long edit.
 *
 * Stored in sessionStorage (this tab only, cleared when the tab closes) and only
 * ever holds the admin's own form content: product/category fields and uploaded
 * image URLs. No passwords, no tokens, no customer data.
 */
const PREFIX = "admin_form_draft:";

function storage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function saveDraft(key, value) {
  const s = storage();
  if (!s) return;
  try {
    s.setItem(PREFIX + key, JSON.stringify({ savedAt: new Date().toISOString(), value }));
  } catch {
    /* quota / private mode — draft recovery is best-effort only */
  }
}

export function readDraft(key) {
  const s = storage();
  if (!s) return null;
  try {
    const raw = s.getItem(PREFIX + key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || !("value" in parsed)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearDraft(key) {
  const s = storage();
  if (!s) return;
  try {
    s.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}

export function draftKey(kind, id) {
  return `${kind}:${id || "new"}`;
}